import { LandingHeading } from "../LandingHeading";
import styles from "./LandingSteps.module.scss";

export interface LandingStep {
  title: string;
  subtitle: string;
}

interface LandingStepsProps {
  title: string;
  steps: LandingStep[];
}

// How a product starts, as numbered steps.
export function LandingSteps({ title, steps }: LandingStepsProps) {
  return (
    <div className={styles.root}>
      <LandingHeading lines={[title]} />
      <ol className={styles.list}>
        {steps.map((step, index) => (
          <li key={step.title} className={styles.step}>
            <span className={styles.number}>{index + 1}</span>
            <p className={styles.title}>{step.title}</p>
            <p className={styles.subtitle}>{step.subtitle}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
